export interface IRegisterPwaParams {
  isOpen: boolean;
}
export function registerPwa(params: IRegisterPwaParams): void {
  if (window.navigator === undefined
    || window.navigator === null
    || navigator.serviceWorker === undefined
    || navigator.serviceWorker === null
  ) {
    return ;
  }
  if (params.isOpen !== true) {
    unregisterPwa();
    return;
  }
  navigator.serviceWorker.register(`/service-worker.js?v=${Date.now()}`, {scope: '/'})
  .then((registration: ServiceWorkerRegistration) => {
    // TODO: 打点 PWA 注册成功
  });
}

function unregisterPwa() {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let i = 0, len = registrations.length; i < len; i++) {
      registrations[i].unregister();
    }
  }).catch(function(e) {
    //
  });
  if (typeof caches !== 'undefined') {
    caches.keys().then(function(keys) {
      keys.forEach(function(k) { caches.delete(k); });
    });
  }
}
